<template>
  <DefaultLoader v-if="isLoading"></DefaultLoader>
  <div v-else class="page-content">
    <div class="top-section">
      <a class="back-button" @click="goBack()">
        <i class="bi bi-arrow-left"></i> Back
      </a>
      <h5 class="page-heading">{{ requestDetails.trip_code }}</h5>
    </div>
    <nav class="partner-nav-holder">
      <div class="nav nav-tabs partner-nav" id="vrDetailsNav-tab">
        <template
          v-for="(route, index) in requestDetails.trip_request_routes"
          :key="index"
        >
          <router-link
            :to="`/trip-request/vehicle-request/details/${route.trip_requests_id}/${route.id}`"
            :class="{ 'nav-link': true, active: requestRoute.id === route.id }"
            >{{ route.route_name }}</router-link
          >
        </template>
      </div>
    </nav>
    <div class="tab-content" id="vrDetailsNav-tabContent">
      <div class="card partner-card">
        <div class="card-header">
          {{ requestRoute.service_type?.name }} Trip Request Proposal
          <div class="button-area">
            <span class="modality">{{
              requestRoute.modality ? requestRoute.modality : 'N/A'
            }}</span>
          </div>
        </div>
        <div class="card-body" style="padding-top: 0">
          <div class="row cell-row">
            <div class="cell w-37">
              <h6>Parent Route</h6>
              <p>
                {{
                  requestDetails.parent_route_name
                    ? requestDetails.parent_route_name
                    : 'N/A'
                }}
              </p>
            </div>
            <div class="cell w-21">
              <h6>Vehicle Type</h6>
              <p>
                {{
                  requestRoute.vehicle_type ? requestRoute.vehicle_type : 'N/A'
                }}
              </p>
            </div>
            <div class="cell w-21">
              <h6>Company</h6>
              <p>
                {{
                  requestRoute.company_code ? requestRoute.company_code : 'N/A'
                }}
              </p>
            </div>
            <div class="cell w-21">
              <h6>Requested By</h6>
              <p>
                {{
                  userDetails[requestDetails.requested_by]
                    ? userDetails[requestDetails.requested_by].name
                    : 'N/A'
                }}
              </p>
            </div>
          </div>
          <div class="row cell-row">
            <div class="cell w-37">
              <h6>Total Distance</h6>
              <p>
                {{
                  requestRoute.distance
                    ? Number(requestRoute.distance).toFixed(2) + ' km'
                    : 'N/A'
                }}
              </p>
            </div>
            <div class="cell w-21">
              <h6>Duty Days</h6>
              <p>
                {{ requestRoute.duty_days ? requestRoute.duty_days : 'N/A' }}
              </p>
            </div>
            <div class="cell w-21">
              <h6>No. of Vehicle</h6>
              <p>
                {{
                  requestRoute.no_of_vehicle
                    ? requestRoute.no_of_vehicle
                    : 'N/A'
                }}
              </p>
            </div>
            <div class="cell w-21">
              <h6>Requested Date</h6>
              <p>
                {{ $format.date(requestDetails.requested_date, 'D/MM/YY') }}
              </p>
            </div>
          </div>
          <div class="row cell-row">
            <div class="cell w-37">
              <h6>Trip Start Time</h6>
              <p>
                {{
                  requestRoute.pick_up_times?.length > 0
                    ? vehicleRequest.pickUpTimes(requestRoute.pick_up_times)
                    : 'N/A'
                }}
              </p>
            </div>
            <div class="cell w-21">
              <h6>Duty Start Date</h6>
              <p>
                {{ $format.date(requestRoute.duty_start_date, 'D/MM/YY') }}
              </p>
            </div>
            <div
              class="cell w-21"
              v-if="requestRoute.modality !== 'fleet-variable'"
            >
              <h6>Week Days</h6>
              <p>
                {{ requestRoute.week_days ? requestRoute.week_days : 'N/A' }}
              </p>
            </div>
            <div
              class="cell w-21"
              v-if="requestRoute.modality !== 'fleet-variable'"
            >
              <h6>Expected Price</h6>
              <p>
                {{
                  requestRoute.expected_price
                    ? requestRoute.expected_price + '/-'
                    : 'N/A'
                }}
              </p>
            </div>
            <div
              class="cell w-21"
              v-if="requestRoute.modality === 'fleet-variable'"
            >
              <h6>Expected Body Rent</h6>
              <p>
                {{
                  requestRoute.expected_body_rent
                    ? requestRoute.expected_body_rent + '/-'
                    : 'N/A'
                }}
              </p>
            </div>
            <div
              class="cell w-21"
              v-if="requestRoute.modality === 'fleet-variable'"
            >
              <h6>Expected Fare/km</h6>
              <p>
                {{
                  requestRoute.expected_fare_per_km
                    ? requestRoute.expected_fare_per_km + '/-'
                    : 'N/A'
                }}
              </p>
            </div>
          </div>
          <div class="row cell-row">
            <div class="cell w-37">
              <h6>Remarks</h6>
              <p>
                {{
                  requestDetails.ops_remark ? requestDetails.ops_remark : 'N/A'
                }}
              </p>
            </div>
            <div class="cell w-21">
              <h6>Service Type</h6>
              <p>
                {{
                  requestDetails.service_type
                    ? requestDetails.service_type.name
                    : 'N/A'
                }}
              </p>
            </div>
            <div
              class="cell w-21"
              v-if="requestRoute.modality !== 'fleet-variable'"
            >
              <h6>Points</h6>
              <p>
                <!-- <span
                    class="partner-hyperlink"
                    @click="vehicleRequest.redirectToMap(requestRoute)"
                    >See Map</span
                  > -->
                <span
                  class="partner-hyperlink"
                  data-bs-toggle="modal"
                  data-bs-target="#mapModal"
                  >See Map</span
                >
              </p>
            </div>
            <div
              class="cell w-21"
              v-if="requestRoute.modality !== 'fleet-variable'"
            >
              <h6>Status</h6>
              <RequestAction
                pageName="trip_details"
                :requestRoute="requestRoute"
                @selectRequest="generateRequestData"
              ></RequestAction>
            </div>
            <div
              class="cell w-21"
              v-if="requestRoute.modality === 'fleet-variable'"
            >
              <h6>Expected Lunch Allowance/day</h6>
              <p>
                {{
                  requestRoute.expected_lunch_allowance_per_day
                    ? requestRoute.expected_lunch_allowance_per_day + '/-'
                    : 'N/A'
                }}
              </p>
            </div>
            <div
              class="cell w-21"
              v-if="requestRoute.modality === 'fleet-variable'"
            >
              <h6>Expected Overtime Pay/hour</h6>
              <p>
                {{
                  requestRoute.expected_overtime_payment_per_hour
                    ? requestRoute.expected_overtime_payment_per_hour + '/-'
                    : 'N/A'
                }}
              </p>
            </div>
          </div>
          <div
            class="row cell-row"
            v-if="requestRoute.modality === 'fleet-variable'"
          >
            <div class="cell w-37">
              <h6>Points</h6>
              <p>
                <span
                  class="partner-hyperlink"
                  data-bs-toggle="modal"
                  data-bs-target="#mapModal"
                  >See Map</span
                >
              </p>
            </div>
            <div class="cell w-21">
              <h6>Status</h6>
              <RequestAction
                pageName="trip_details"
                :requestRoute="requestRoute"
                @selectRequest="generateRequestData"
              ></RequestAction>
            </div>
          </div>
        </div>
      </div>
      <div
        class="card partner-card"
        id="setTRPrice"
        v-if="
          requestRoute.setTRPrice &&
          $userPermission.has('vehicle-request-set-price')
        "
      >
        <SetTRPrice
          :bonusTypes="bonusTypes"
          :requestDetails="requestDetails"
          :requestRoute="requestRoute"
          @refreshData="getRequestDetails"
          @cancelTRPriceUpdate="requestRoute.setTRPrice = false"
        ></SetTRPrice>
      </div>
      <div
        class="card partner-card"
        v-if="requestRoute.fare_per_km && !requestRoute.setTRPrice"
      >
        <div class="card-header">
          From Partner Team
          <div class="button-area">
            <span
              v-if="$userPermission.has('vehicle-request-set-price')"
              class="edit-button"
              @click="requestRoute.setTRPrice = true"
            >
              <i class="bi bi-pencil-square"></i>
            </span>
          </div>
        </div>
        <div class="card-body" style="padding-top: 0">
          <div
            class="row cell-row"
            v-if="requestRoute.modality === 'fleet-variable'"
          >
            <div class="cell w-25">
              <h6>Fare Per KM</h6>
              <p>
                {{
                  requestRoute.fare_per_km
                    ? requestRoute.fare_per_km + 'TK'
                    : 'N/A'
                }}
              </p>
            </div>
            <div class="cell w-25">
              <h6>Body Rent</h6>
              <p>
                {{
                  requestRoute.body_rent ? requestRoute.body_rent + 'TK' : 'N/A'
                }}
              </p>
            </div>
            <div class="cell w-25">
              <h6>Over Time/Hour Rate</h6>
              <p>
                {{
                  requestRoute.overtime_payment_per_hour
                    ? requestRoute.overtime_payment_per_hour + 'TK'
                    : 'N/A'
                }}
              </p>
            </div>
            <div class="cell w-25">
              <h6>Lunch Allowance/Day</h6>
              <p>
                {{
                  requestRoute.lunch_allowance_per_day
                    ? requestRoute.lunch_allowance_per_day + 'TK'
                    : 'N/A'
                }}
              </p>
            </div>
          </div>
          <div
            class="row cell-row"
            v-else-if="requestRoute.modality === 'fleet-fixed'"
          >
            <div class="cell w-25">
              <h6>Fare Per KM</h6>
              <p>
                {{
                  requestRoute.fare_per_km
                    ? requestRoute.fare_per_km + 'TK'
                    : 'N/A'
                }}
              </p>
            </div>
            <div class="cell w-25">
              <h6>Body Rent</h6>
              <p>
                {{
                  requestRoute.body_rent ? requestRoute.body_rent + 'TK' : 'N/A'
                }}
              </p>
            </div>
            <div class="cell w-25">
              <h6>Lunch Allowance/Day</h6>
              <p>
                {{
                  requestRoute.lunch_allowance_per_day
                    ? requestRoute.lunch_allowance_per_day + 'TK'
                    : 'N/A'
                }}
              </p>
            </div>
          </div>
          <div class="row cell-row" v-else>
            <div class="cell w-25">
              <h6>Daily Income</h6>
              <p class="sub-heading">(Without Completion Bonus)</p>
              <p class="highlighted-text">
                {{
                  vehicleRequest.dailyIncomeWithShuttleBonus(
                    requestRoute.fare_per_km,
                    requestRoute.distance,
                    requestRoute.duty_days,
                    requestRoute.pick_up_times?.length,
                    vehicleRequest.shuttleBonusObjFromBonusArray(
                      requestRoute.trip_request_bonuses,
                      bonusObj
                    ).type,
                    vehicleRequest.shuttleBonusObjFromBonusArray(
                      requestRoute.trip_request_bonuses,
                      bonusObj
                    ).base_bonus
                  )
                }}
                TK
              </p>
            </div>
            <div class="cell w-25">
              <h6>Weekly Income</h6>
              <p class="sub-heading">(Without Completion Bonus)</p>
              <p class="highlighted-text">
                {{
                  vehicleRequest.weeklyIncomeWithShuttleBonus(
                    requestRoute.fare_per_km,
                    requestRoute.distance,
                    requestRoute.duty_days,
                    requestRoute.pick_up_times?.length,
                    vehicleRequest.shuttleBonusObjFromBonusArray(
                      requestRoute.trip_request_bonuses,
                      bonusObj
                    ).type,
                    vehicleRequest.shuttleBonusObjFromBonusArray(
                      requestRoute.trip_request_bonuses,
                      bonusObj
                    ).base_bonus
                  )
                }}
                TK
              </p>
            </div>
            <!-- <div class="cell w-25">
              <h6>Weekly Income</h6>
              <p class="sub-heading">(All Bonus Included)</p>
              <p class="highlighted-text">
                {{
                  vehicleRequest.weeklyIncomeWithShuttleAndCompletionBonus(
                    requestRoute.fare_per_km,
                    requestRoute.distance,
                    requestRoute.duty_days,
                    requestRoute.pick_up_times?.length,
                    vehicleRequest.shuttleBonusObjFromBonusArray(
                      requestRoute.trip_request_bonuses,
                      bonusObj
                    ).type,
                    vehicleRequest.shuttleBonusObjFromBonusArray(
                      requestRoute.trip_request_bonuses,
                      bonusObj
                    ).base_bonus,
                    vehicleRequest.completionBonusFromBonusArray(
                      requestRoute.trip_request_bonuses,
                      bonusObj
                    )
                  )
                }}
                TK
              </p>
            </div> -->
            <div class="cell w-25">
              <h6>Fare Per KM</h6>
              <p>{{ requestRoute.fare_per_km }} TK</p>
            </div>
            <div
              v-for="(bonus, bonusIndex) in requestRoute.trip_request_bonuses"
              :key="bonusIndex"
              class="cell w-25"
            >
              <h6>
                {{
                  bonusObj[bonus.bonus_id]
                    ? bonusObj[bonus.bonus_id].bonus_name
                    : 'N/A Bonus'
                }}
              </h6>
              <p>
                {{ bonus.base_bonus }}
                {{ bonus.type === 'percentage' ? '%' : 'TK' }}
              </p>
              <p
                class="text-warning"
                style="font-size: 12px"
                v-if="
                  bonusObj[bonus.bonus_id]?.bonus_name === 'Completion Bonus'
                "
              >
                <i class="bi bi-info-circle"></i> Completion bonus will be
                calculated for both routes.
              </p>
            </div>
            <div
              class="cell w-25"
              v-if="
                vehicleRequest.returnRoute(
                  requestDetails.trip_request_routes,
                  requestRoute.id
                )
              "
            >
              <h6>TR For Return Route</h6>
              <p>
                {{
                  vehicleRequest.returnRoute(
                    requestDetails.trip_request_routes,
                    requestRoute.id
                  ).route_name
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        class="card partner-card"
        v-if="requestRoute.all_drivers_details?.length > 0"
      >
        <div class="card-header">Driver Info</div>
        <div class="card-body table-responsive">
          <table class="table partner-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Phone No.</th>
                <!-- <th>Vehicle Type</th> -->
                <!-- <th>Garage Location</th> -->
                <th>Type</th>
                <th>Status</th>
                <!-- <th>Driver Type</th> -->
                <th>Contract Details</th>
                <!-- <th>Remarks</th> -->
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(
                  driverDetails, index
                ) in requestRoute.all_drivers_details"
                :key="index"
              >
                <td>{{ userDetails[driverDetails.partner_id]?.name }}</td>
                <td>{{ userDetails[driverDetails.partner_id]?.mobile }}</td>
                <!-- <td></td> -->
                <!-- <td></td> -->
                <td>
                  <span class="partner-badge partner-badge-pink rounded-pill">{{
                    driverDetails.backup_partner ? 'Backup' : 'Regular'
                  }}</span>
                </td>
                <td>
                  <span class="partner-badge partner-badge-pink rounded-pill">{{
                    driverDetails.status
                  }}</span>
                </td>
                <!-- <td></td> -->
                <td>
                  <span
                    v-if="
                      $userPermission.has('vehicle-request-driver-assign') &&
                      !driverDetails.backup_partner
                    "
                    class="partner-hyperlink"
                    data-bs-toggle="modal"
                    data-bs-target="#driverCDModal"
                    @click="selectedDriverDetails = driverDetails"
                    >See Details</span
                  >
                </td>
                <!-- <td>
                    <span
                      class="partner-hyperlink"
                      data-bs-toggle="modal"
                      data-bs-target="#remarksForDriverModal"
                      @click="
                        selectedDriverDetails = driverDetails;
                      "
                      >See Details</span
                    >
                  </td> -->
                <td>
                  <button
                    v-if="
                      driverDetails.status === 'Assigned' &&
                      $userPermission.has('vehicle-request-driver-assign') &&
                      !driverDetails.backup_partner
                    "
                    class="btn btn-xs btn-warning unassign-driver-btn"
                    @click="unassignDriver(driverDetails)"
                  >
                    Unassign Driver
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div
        v-if="
          requestRoute.fare_per_km &&
          !requestRoute.assigned_driver_details &&
          $userPermission.has('vehicle-request-driver-assign')
        "
        class="card partner-card"
        id="assignDriver"
      >
        <div class="card-body">
          <div class="no-driver-portion">
            <img src="../../assets/icon/sadIcon.png" alt="Sad Icon" />
            <h4>No driver is assigned yet!</h4>
            <p>This TR doesn’t have any driver assigned.</p>
            <button
              class="btn btn-primary"
              data-bs-toggle="modal"
              data-bs-target="#assignDriverModal"
            >
              Assign Driver
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Assign Driver Modal -->
  <teleport to="body">
    <div
      class="modal fade partner-modal"
      id="assignDriverModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div class="modal-dialog modal-lg">
        <AssignDriver
          :requestDetails="requestDetails"
          :selectedRouteIndex="selectedRouteIndex"
          :bonusObj="bonusObj"
          @refreshData="getRequestDetails"
        ></AssignDriver>
      </div>
    </div>
  </teleport>

  <!-- Driver CD Modal -->
  <teleport to="body">
    <div
      class="modal fade partner-modal"
      id="driverCDModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div class="modal-dialog modal-lg">
        <DriverCD
          :requestRoute="requestRoute"
          :bonusObj="bonusObj"
          :driverDetails="selectedDriverDetails"
          @refreshData="getRequestDetails"
        ></DriverCD>
      </div>
    </div>
  </teleport>

  <!-- Driver Remarks Modal -->
  <teleport to="body">
    <div
      class="modal fade partner-modal"
      id="remarksForDriverModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div class="modal-dialog modal-lg">
        <RemarksForDrivers
          :requestRoute="requestRoute"
          :driverDetails="selectedDriverDetails"
          @refreshData="getRequestDetails"
        ></RemarksForDrivers>
      </div>
    </div>
  </teleport>

  <!-- Map Modal -->
  <teleport to="body">
    <div
      class="modal fade partner-modal"
      id="mapModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Map</h5>
            <button
              ref="modalCloseBtn"
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i class="bi bi-x-circle"></i>
            </button>
          </div>
          <div class="modal-body">
            <DirectionMap :mapData="requestRoute?.route_map"></DirectionMap>
          </div>
        </div>
      </div>
    </div>
  </teleport>

  <!-- Proposal Modal -->
  <teleport to="body">
    <div
      class="modal fade partner-modal"
      id="proposalModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-sm">
        <Proposal
          :request="requestRoute"
          @refreshData="getRequestDetails()"
        ></Proposal>
      </div>
    </div>
  </teleport>

  <!-- Remarks (Partners) Modal -->
  <teleport to="body">
    <div
      class="modal fade partner-modal"
      id="remarksPartnersModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <RemarksPartners
          :request="requestRoute"
          @refreshData="getRequestDetails()"
        ></RemarksPartners>
      </div>
    </div>
  </teleport>

  <!-- Cancel Proposal Modal -->
  <teleport to="body">
    <div
      class="modal fade partner-modal"
      id="cancelProposalModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-sm">
        <CancelProposal
          :request="requestRoute"
          @refreshData="getRequestDetails()"
        ></CancelProposal>
      </div>
    </div>
  </teleport>
</template>

<script>
import AssignDriver from '../tripRequest/vehicleRequest/AssignDriver.vue';
import http from '../../config/axios';
import userServiceAPI from '../../store/userServiceAPI';
import SetTRPrice from '../tripRequest/vehicleRequest/SetTRPrice.vue';
import { vehicleRequest } from '../../store/vehicleRequest/vehicleRequest';
import helpers from '../../store/helpers';
import DriverCD from '../tripRequest/vehicleRequest/DriverCD.vue';
import RemarksForDrivers from '../tripRequest/vehicleRequest/RemarksForDrivers.vue';
import DirectionMap from '../tripRequest/map/DirectionMap.vue';
import RequestAction from '../tripRequest/vehicleRequest/RequestAction.vue';
import Proposal from '../tripRequest/vehicleRequest/Proposal.vue';
import CancelProposal from '../tripRequest/vehicleRequest/CancelProposal.vue';
import RemarksPartners from '../tripRequest/vehicleRequest/RemarksPartners.vue';

export default {
  components: {
    AssignDriver,
    SetTRPrice,
    DriverCD,
    RemarksForDrivers,
    DirectionMap,
    RequestAction,
    Proposal,
    CancelProposal,
    RemarksPartners
  },
  data() {
    return {
      isLoading: false,
      isBonusLoading: false,
      currentHistoryPosition: 0,
      routerDepth: -1,
      routeShouldGoBack: true,
      requestDetails: {},
      selectedDriverDetails: {},
      userDetails: {},
      bonusTypes: [],
      bonusIds: {},
      bonusObj: {},
      vehicleRequest,
      helpers
    };
  },
  mounted() {
    this.getRequestDetails();
    this.getBonusTypes();
    this.initBackBtn();
  },
  watch: {
    $route: {
      handler: function () {
        if (
          this.currentHistoryPosition >
          this.$router.options.history.state.position
        ) {
          this.routerDepth++;
        } else {
          this.routerDepth--;
        }
        this.currentHistoryPosition =
          this.$router.options.history.state.position;
      },
      deep: true
    }
  },
  computed: {
    selectedRouteIndex() {
      let index = 0;

      if (
        this.$route.params.route_id &&
        this.requestDetails?.trip_request_routes?.length > 0
      ) {
        this.requestDetails.trip_request_routes.forEach((route, i) => {
          if (route.id == this.$route.params.route_id) {
            index = i;
          }
        });
      }

      return index;
    },
    requestRoute() {
      let requestRoute = {};

      if (
        this.$route.params.route_id &&
        this.requestDetails?.trip_request_routes?.length > 0
      ) {
        this.requestDetails.trip_request_routes.forEach((route) => {
          if (route.id == this.$route.params.route_id) {
            requestRoute = route;
          }
        });
      } else if (this.requestDetails?.trip_request_routes?.length > 0) {
        requestRoute = this.requestDetails.trip_request_routes[0];
      }

      return requestRoute;
    }
  },
  methods: {
    initBackBtn() {
      this.currentHistoryPosition = this.$router.options.history.state.position;
      if (
        !this.currentHistoryPosition ||
        !this.$router.options.history.state.back ||
        this.$router.options.history.state.forward
      ) {
        this.routeShouldGoBack = false;
      }
    },
    goBack() {
      if (this.routeShouldGoBack) {
        this.$router.go(this.routerDepth);
      } else {
        this.$router.push({
          name: 'vehicle-request'
        });
      }
    },
    mapBonus() {
      this.bonusTypes.forEach((element) => {
        this.bonusIds[element.bonus_name] = element.id;
        this.bonusObj[element.id] = element;
      });
    },
    setTRPriceUpdateStatus() {
      this.requestDetails.trip_request_routes.forEach((requestRoute) => {
        if (requestRoute.status === 'Accepted' && !requestRoute.fare_per_km) {
          requestRoute.setTRPrice = true;
        }
      });
    },
    getUserCodesFromRequestDetails(data) {
      let userCodes = new Set();
      if (data.requested_by) {
        userCodes.add(data.requested_by);
      }
      if (data.trip_request_routes) {
        data.trip_request_routes.forEach((route) => {
          if (route.km_checked_by) {
            userCodes.add(route.km_checked_by);
          }
          if (route.all_drivers_details) {
            route.all_drivers_details.forEach((driverDetails) => {
              if (driverDetails.partner_id) {
                userCodes.add(driverDetails.partner_id);
              }
            });
          }
        });
      }
      return [...userCodes];
    },
    setUserDetails(data) {
      data.forEach((ele) => {
        this.userDetails[ele.user_code] = ele;
      });
    },
    getRequestDetails() {
      this.isLoading = true;

      http
        .get(
          `v2/partners/triprequests/${this.$route.params.trip_request_id}/routes`
        )
        .then((response) => {
          this.requestDetails = response.data.data ? response.data.data : {};
          this.setTRPriceUpdateStatus();
          let allUserCodes = this.getUserCodesFromRequestDetails(
            this.requestDetails
          );

          // Fetch users from user service
          userServiceAPI
            .getUserDetails(allUserCodes)
            .then((res) => {
              this.isLoading = false;
              this.setUserDetails(res.data.data);
            })
            .catch(() => {
              this.isLoading = false;
            });
        })
        .catch((error) => {
          this.isLoading = false;
          this.$partnerSwal.errorToast.fire({
            title: 'Error!',
            text: error.response?.data?.message
          });
        });
    },
    getBonusTypes() {
      this.isBonusLoading = true;
      http
        .get('v2/partners/bonus')
        .then((response) => {
          this.isBonusLoading = false;
          this.bonusTypes = response.data.data;
          this.mapBonus();
        })
        .catch((error) => {
          this.isBonusLoading = false;
          this.$partnerSwal.errorToast.fire({
            title: 'Error Loading Bonus Types!',
            text: error.response.data?.message
          });
        });
    },
    unassignDriver(driverDetails) {
      this.$partnerSwal.confirmationAlert
        .fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          confirmButtonText: 'Unassign!'
        })
        .then((result) => {
          if (result.isConfirmed) {
            http
              .patch(`v2/partners/triprequestpartners/${driverDetails.id}`, {
                status: 'Unassigned'
              })
              .then((response) => {
                this.getRequestDetails();
                this.$partnerSwal.quickSuccessAlert.fire({
                  title: 'Success',
                  text: response.data?.message
                });
              })
              .catch((error) => {
                this.isLoading = false;
                this.$partnerSwal.errorToast.fire({
                  title: 'Error!',
                  text: error.response?.data?.message
                });
              });
          }
        });
    },
    generateRequestData() {
      this.requestRoute.service_type = this.requestDetails.service_type;
      this.requestRoute.ops_remark = this.requestDetails.ops_remark;
    }
  }
};
</script>

<style scoped>
.back-button {
  cursor: pointer;
  display: inline-block;
  font-size: 16px;
  font-weight: 500;
  margin-left: 15px;
  margin-bottom: 6px;
}
.page-heading {
  margin: 20px 0;
  font-size: 20px;
  font-weight: 600;
  color: #121212;
}
.partner-nav-holder {
  overflow: hidden;
}
.partner-card {
  margin-top: 24px;
}
.cell {
  float: left;
  margin-top: 28px;
}
.cell h6 {
  font-weight: 600;
  font-size: 16px;
  line-height: 16px;
  margin-bottom: 4px;
}
.cell p {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 0;
}

.no-driver-portion {
  text-align: center;
  color: #949494;
}
.no-driver-portion img {
  width: 43px;
  margin-bottom: 23px;
}
.no-driver-portion h4 {
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;
  margin-bottom: 0;
}
.no-driver-portion p {
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 12px;
}
.no-driver-portion .btn {
  padding: 9px 56px;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
}
.sub-heading {
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 14px !important;
  margin-bottom: 6px !important;
}
.highlighted-text {
  font-weight: 600 !important;
  color: #652f8f;
}
.modality {
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #a95eea;
  background: rgba(169, 94, 234, 0.1);
  border: 1px solid #a95eea;
  border-radius: 24px;
  padding: 8px 12px;
}

.unassign-driver-btn {
  color: #fff;
}

.edit-button {
  cursor: pointer;
  color: #652f8f;
}
.edit-button:hover {
  cursor: pointer;
  color: #a95eea;
}

:deep(.partner-badge) {
  font-size: 13px;
}
:deep(.dropdown) {
  width: 110px;
}

.w-37 {
  width: 37% !important;
}
.w-21 {
  width: 21% !important;
}
.w-25 {
  width: 25%;
}
@media only screen and (max-width: 768px) {
  .w-37 {
    width: 100% !important;
  }
  .w-21 {
    width: 100% !important;
  }
  .w-25 {
    width: 100% !important;
  }
}
</style>
